import { useContext } from "react";
import { SearchContext } from "../provider/search-provider";

export function useSearch() {
    const ctx = useContext(SearchContext);
    if (!ctx) throw new Error("SearchProvider missing");
    return ctx;
}
